import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { clients } from './modules/clients'
import { auth } from './modules/auth'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const store = new Vuex.Store({
    state: {
        accessPoint: null,
        activeRequests: 0,
        administrativeUsers: [],
        alarms: [],
        alertNotifications: [],
        annotationTypes: [],
        arls: [],
        assignedClients: [],
        capabilities: [],
        cities: [],
        client: null,
        clients: [],
        clientTypes: [],
        currentMenu: null,
        executives: [],
        identificationTypes: [],
        inProgress: false,
        itemTypes: [],
        loaded: [],
        mail: [],
        mailTypes: [],
        menuOptions: [],
        months: [],
        notes: [],
        otherClients: [],
        passengerTypes: [],
        people: [],
        personEntries: [],
        petitionStatuses: [],
        petitionTypes: [],
        positions: [],
        profiles: [],
        restrictedVisitors: [],
        selectedUser: null,
        selectedStore: null,
        selectedBodyguardService: null,
        selectedRound: null,
        shift: null,
        structureTypes: [],
        supervisor: null,
        supervisors: [],
        supervisionClient: '',
        tools: [],
        user: null,
        vehicleEntries: [],
        vehicleEntryTypes: [],
        vehicleTypes: [],
        venuePeople: [],
        years: [],
        currentEvaluation: [],
        currentEvaluatedUser: [],
    },
    getters,
    mutations,
    actions,
})
